document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-apie-experience]').forEach((root) => {
        if (root.dataset.experienceReady === '1') {
            return;
        }
        root.dataset.experienceReady = '1';

        const slides = Array.from(root.querySelectorAll('[data-experience-slide]'));
        if (slides.length < 2) {
            return;
        }

        let current = 0;
        const prevBtn = root.querySelector('[data-experience-prev]');
        const nextBtn = root.querySelector('[data-experience-next]');

        const showSlide = (index) => {
            current = (index + slides.length) % slides.length;

            slides.forEach((slide, i) => {
                const match = i === current;
                slide.classList.toggle('is-active', match);
                slide.toggleAttribute('hidden', !match);
            });
        };

        prevBtn?.addEventListener('click', () => showSlide(current - 1));
        nextBtn?.addEventListener('click', () => showSlide(current + 1));
    });
});
